import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import { CustomerQueryKeys } from "../Customer/keys";

export default function useCustomerBranding(customerId: string) {
  const queryClient = useQueryClient();
  const { saveHandlers } = useDefaultCRUDHandlers("Customer Branding");
  const { postDocs, put } = useApiHelper();

  const upload = useMutation({
    mutationFn: ({
      brandId,
      isCropped = false,
      isWidgetEmailDisplayLogo = false,
      data,
    }: {
      brandId: string;
      isCropped: boolean;
      isWidgetEmailDisplayLogo: boolean;
      data: FormData;
    }) => postDocs(`/brand/${brandId}/upload?isCropped=${isCropped}&isWidgetEmailDisplayLogo=${isWidgetEmailDisplayLogo}`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: CustomerQueryKeys.single(customerId),
      });
      saveHandlers.onSuccess();
    },
    onError: () => {
      saveHandlers.onError();
    },
  });

  const updateColour = useMutation({
    mutationFn: (data: any) => put(`/brand/colour/${data.brandId}`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: CustomerQueryKeys.single(customerId),
      });
      saveHandlers.onSuccess();
    },
    onError: () => {
      saveHandlers.onError();
    },
  });

  return {
    upload,
    updateColour,
  };
}
